import MarketStateSnapshotTools
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/MarketStateSnapshotTools';
import { useContext } from 'react';
import {
	MarketStateToolsContext,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/provider/MarketStateToolsProvider';


export const useMarketStateTools = (): MarketStateSnapshotTools => useContext(MarketStateToolsContext)!;